import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {AbstractListView} from "../../../core/visbos-core/ui/components/abstract-list-view";
import {SessionActions} from "../../../shared/actions/session.actions";
import {DatatableComponent} from "../../../core/visbos-core/ui/components/datatable/datatable.component";
import {GenericModalComponent} from "../../../core/visbos-core/ui/forms/generic-modal/generic-modal.component";
import {Vehicle} from "../../model/vehicle.type";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {VehicleFormComponent} from "../vehicle-form/vehicle-form.component";
import {FleetService} from "../../services/fleet.service";
import {MessageType} from "../../../shared/redux-store/session/session.types";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";

@Component({
  selector: 'vb-vehicles-list',
  templateUrl: './vehicles-list.component.html',
  styleUrls: ['./vehicles-list.component.css']
})
export class VehiclesListComponent extends AbstractListView implements OnInit, OnChanges {

  @ViewChild('vehiclesTable')
  vehiclesTable: DatatableComponent;

  @ViewChild('vehicleModal')
  vehicleModal: GenericModalComponent;

  @Input()
  vehicleList: Vehicle[] = [];

  currentVehicleItem: Vehicle;
  currentVehicleControl: FormGroup;

  selected: string[] = [];

  @Output()
  selectedChange: EventEmitter<string[]> = new EventEmitter();

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder,
              private fleetService: FleetService) {
    super(sessionActions, cd);
  }

  ngOnInit() {

    super.ngOnInit();

    this.columns = [
      {prop: 'license_plate', name: 'Kennzeichen', flexGrow: 2},
      {prop: 'administration_unit.label', name: 'Standort', flexGrow: 2},
      {prop: 'identities.0.ean', name: 'EAN', flexGrow: 1},
    ];

    this.searchTerm = new FormControl();

    this.dataSubscriptions.push(
      this.searchTerm.valueChanges.pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe((term: any) => this.filterItems(term))
    );

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.vehicleList) {
      this.rows = this.vehicleList;
    }
  }

  onEditVehicleClicked(vehicle: Vehicle) {
    this.currentVehicleItem = vehicle;
    this.currentVehicleControl = VehicleFormComponent.initControl(this.fb);
    this.vehicleModal.show();
  }

  onSaveVehicleClicked() {
    const vehicleData = this.currentVehicleControl.value;
    this.fleetService.updateVehicle(vehicleData.cuid, vehicleData).toPromise()
      .then(res => this.sessionActions.pushMessage("Fahrzeugdaten erfolgreich geändert!", MessageType.SUCCESS))
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Ändern der Fahrzeugdaten!"));
  }

  onDeleteVehicleClicked(vehicle: Vehicle) {
    this.fleetService.deleteVehicle(vehicle.cuid).toPromise()
      .then(res => this.sessionActions.pushMessage("Fahrzeug gelöscht!", MessageType.SUCCESS))
      .catch(err => this.sessionActions.throwError(err, "Fehler beim Löschen des Fahrzeugs!"));
  }

  filterItems(searchTerm) {
    if (!searchTerm || searchTerm == "") {
      this.rows = this.vehicleList;
    } else {
      if (this.vehicleList) {
        this.rows = this.vehicleList.filter((si: any) => this.findStringInTable(si, this.columns, searchTerm));
      }
    }
  }

  onCellUpdate(row, res, index) {
  }

  onSelectedChanged(selected: string[]) {
    this.selected = [...selected];
    this.selectedChange.emit(this.selected);
  }

}



// WEBPACK FOOTER //
// ./src/app/fleet/components/vehicles-list/vehicles-list.component.ts